﻿export function travelCertPageData(state = {}, action) {
    switch (action.type) {
        case 'TRAVEL_CERT_PAGE_LOADED':
            return {
                ...state,
                ...action.data
            };

        case 'TRAVEL_CERT_PAGE_MAIL_SENT_STATUS':
            return {
                ...state,
                travelCertMailSent: action.travelCertMailSent
            };

        default:
            return state;
    }
}